<template>
  <v-row :no-gutters="mobile">
    <v-col
      cols="12"
      md="2"
      :class="{
        'pr-0': !mobile,
        'pb-7': !mobile,
        'pa-0': mobile,
        'pb-0': mobile
      }"
    >
      <v-card
        :class="{
          'pt-2': true,
          'card-check-behind': !mobile,
          'card-check': mobile,
          'pa-4': !mobile,
          'px-6': !mobile,
          'px-4': mobile,
          'pb-0': mobile,
          'd-flex': true,
          'flex-column': true,
          'justify-space-around': !mobile,
          'rounded-bl-0': mobile,
          'rounded-br-0': mobile
        }"
        :elevation="!mobile ? 2 : 0"
      >
        <div>
          <p class="caption">Sequence #</p>
          <p v-if="property.indexes && property.indexes.pdcs">
            <b>{{ property.indexes.pdcs + index + 1 }}</b>
          </p>
          <p v-else>
            <b>{{ index }}</b>
          </p>
        </div>
        <div class="mt-0">
          <v-select
            v-model="item.category"
            :items="paymentCategories"
            label="Category"
            class="pt-0"
            dense
          ></v-select>
        </div>

        <div>
          <p :class="{ caption: true, 'mt-1': mobile }">Start date:</p>
          <p v-if="!item.startDate">
            <strong>{{ 'x' }}</strong>
          </p>
          <v-menu
            v-else
            v-model="item.startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :disabled="item.tenantId < 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="text-small"
                solo
                flat
                dense
                readonly
                hide-details
                :value="formatDate(item.startDate)"
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="item.startDate"
              no-title
              scrollable
              @input="item.startDateMenu = false"
            >
            </v-date-picker>
          </v-menu>
          <p :class="{ caption: true, 'mt-2': !mobile, 'mt-1': mobile }">
            End date:
          </p>
          <p v-if="!item.endDate">
            <strong>{{ 'x' }}</strong>
          </p>
          <v-menu
            v-else
            v-model="item.endDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :disabled="item.tenantId < 0"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                class="text-small"
                solo
                flat
                dense
                readonly
                hide-details
                :value="formatDate(item.endDate)"
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>
            </template>
            <v-date-picker
              v-model="item.endDate"
              no-title
              scrollable
              @input="item.endDateMenu = false"
            >
            </v-date-picker>
          </v-menu>
        </div>

        <v-btn
          v-if="index > 0"
          small
          color="red"
          dark
          depressed
          @click="removePDC(index)"
          ><v-icon class="mr-1" small>mdi-close</v-icon>Remove PDC</v-btn
        >
      </v-card>
    </v-col>
    <v-col
      cols="12"
      md="10"
      :class="{
        'pl-0': !mobile,
        'pa-0': mobile
      }"
    >
      <v-card
        :class="{
          'mb-4': true,
          'px-4': !mobile,
          'pl-8': !mobile,
          'pt-2': !mobile,
          'card-check': true,
          'rounded-tl-0': mobile,
          'rounded-tr-0': mobile
        }"
        :elevation="!mobile ? 2 : 0"
      >
        <v-container>
          <v-row>
            <v-col cols="12" md="3" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-select
                v-model="item.tenantId"
                solo
                flat
                dense
                hint="Tenant *"
                persistent-hint
                placeholder="Select Tenant Here"
                :items="
                  tenantsList.filter((t) =>
                    t.text
                      .toLowerCase()
                      .includes(searchTenantsList.toLowerCase())
                  )
                "
                :rules="tenantRules"
                @change="changeTenantLocal(index)"
              >
                <template v-slot:prepend-item>
                  <v-list-item ripple>
                    <v-list-item-content>
                      <v-text-field
                        v-model="searchTenantsList"
                        outlined
                        dense
                        hide-details
                        placeholder="Search Tenant"
                      ></v-text-field>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider class="mt-2"></v-divider>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="3" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-select
                v-model="item.unit"
                solo
                flat
                dense
                hint="Select Unit *"
                persistent-hint
                placeholder="Select Unit Here"
                :items="tenantUnits"
                :rules="unitRules"
                :disabled="!tenantUnits.length"
                @change="changeTenant(index)"
              ></v-select>
            </v-col>
            <v-col cols="12" md="2" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-text-field
                v-model="item.routingNumber"
                solo
                flat
                dense
                hint="Routing No."
                persistent-hint
                placeholder="xxxxxxxx"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-text-field
                v-model="item.accountNumber"
                solo
                flat
                dense
                hint="Account No."
                persistent-hint
                placeholder="xxxxxxxx"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-text-field
                v-model="item.checkNumber"
                solo
                flat
                dense
                hint="Check No. *"
                persistent-hint
                placeholder="xxxxxxxx"
                :rules="checkNumberRules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="9" :class="{ 'pr-1': !mobile, 'pb-0': true }">
              <v-text-field
                dense
                label="Pay to the order of"
                :placeholder="property.propertyName"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" :class="{ 'pr-1': !mobile, 'pb-0': true }">
              <v-menu
                v-model="item.dateMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
                :disabled="item.tenantId < 0"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    flat
                    dense
                    readonly
                    hint="Check Date *"
                    persistent-hint
                    :value="formatDate(item.date)"
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      setSelectedLastRentalDate(
                        item.unit.nextRentalPeriod.startDate
                      )
                    "
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="item.date"
                  no-title
                  scrollable
                  @input="item.dateMenu = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="8" :class="{ 'pr-1': !mobile, 'pt-0': true }">
              <v-text-field
                v-model="item.description"
                solo
                flat
                dense
                hint="Description"
                persistent-hint
                placeholder="Enter Description Here"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" :class="{ 'pr-1': !mobile, 'pt-0': true }">
              <v-currency-field
                v-model="item.amount"
                solo
                flat
                dense
                hint="Amount (Rent Fee) *"
                persistent-hint
                placeholder="Php x,xxx.xx"
              ></v-currency-field>
            </v-col>
            <!-- <v-col cols="12" md="3" :class="{'pr-1': !mobile, 'py-0': true}">
              <v-text-field solo flat dense label="Attachments"></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="4" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-text-field
                v-model="item.bank"
                solo
                flat
                dense
                hint="Bank / Branch *"
                persistent-hint
                placeholder="My Secure Bank - West Branch"
                :rules="bankRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" :class="{ 'pr-1': !mobile, 'py-0': true }">
            </v-col>
            <v-col cols="12" md="6" :class="{ 'pr-1': !mobile, 'py-0': true }">
              <v-file-input
                v-model="item.attachments"
                accept="image/*, application/pdf"
                label="Click Here to attach files"
                dense
                chips
                small-chips
                multiple
              ></v-file-input>
            </v-col>
          </v-row>
          <v-row
            :class="{
              'd-flex': !mobile,
              'flex-row': !mobile,
              'justify-space-around': !mobile,
              'px-1': mobile
            }"
          >
            <p class="caption">
              Last rental payment made on
              <b>{{ item.lastRentalDate || 'x' }}</b> and is valid until
              <b>{{ item.lastRentalDateEnd || 'x' }}</b>
            </p>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { dayjs } from '../../util/date'
import { forbiddenCreatePDCCategories } from '../../config/pdc'

export default {
  props: [
    'item',
    'index',
    'property',
    'removePDC',
    'tenantsList',
    'changeTenant'
  ],
  data() {
    return {
      tenantRules: [(v) => v > -1 || 'Please select a tenant'],
      dateRules: [(v) => !!v || 'Check date is required'],
      bankRules: [(v) => !!v || 'Bank is required'],
      routingNumberRules: [(v) => !!v || 'Routing Number is required'],
      checkNumberRules: [(v) => !!v || 'Check Number is required'],
      amountRules: [(v) => v > 0 || 'Amount must be greater than 0'],
      unitRules: [(v) => !!v || 'Please select a unit'],
      selectedLastRentalDate: null,
      searchTenantsList: '',
      tenantUnits: []
    }
  },
  computed: {
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    paymentCategories() {
      return this.property.payment_categories_details[0].categories.filter(
        (category) => !forbiddenCreatePDCCategories.includes(category.value)
      )
    }
  },
  methods: {
    allowedDates(val) {
      return dayjs(val).isSameOrAfter(
        dayjs(this.selectedLastRentalDate).add(1, 'month'),
        'day'
      )
    },
    setSelectedLastRentalDate(date) {
      this.selectedLastRentalDate = date
    },
    async changeTenantLocal(index) {
      // this.changeTenant(index)
      this.tenantUnits = this.units
        .filter((unit) => unit.tenantId === this.item.tenantId)
        .map((unit) => {
          return {
            value: unit,
            text: unit.bedName
          }
        })
      if (this.tenantUnits.length === 1) {
        this.item.unit = this.tenantUnits[0].value
        this.changeTenant(index)
      } else {
        this.item.unit = null
      }
      // const units = await this.$store.dispatch('units/fetchTenantUnits', {
      //   tenantId: this.item.tenantId
      // })
      // this.units = units.map(unit => {
      //   return {
      //     value: unit.bedId,
      //     text: unit.bedName,
      //   }
      // })
    },
    formatDate(date) {
      return dayjs(date).format('MMM DD, YYYY')
    }
  }
}
</script>

<style scoped>
.v-card.card-check {
  background-color: #ecebea;
}
.v-card.card-check-behind {
  background-color: #f1f2ee;
  height: 100%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 4;
}
.v-card.card-check-behind:after {
  top: 0;
  left: -10px;
  content: '';
  width: 10px;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  background: linear-gradient(-137deg, #f1f2ee 6px, transparent 0) 0 5px,
    linear-gradient(320deg, #f1f2ee 6px, transparent 0) 0 5px;
  background-position: left;
  background-repeat: repeat-y;
  background-size: 10px 10px;
}

.v-card.card-check-behind:after {
  left: auto;
  right: -10px;
  top: 0;
  transform: scaleX(-1);
}

.text-small {
  font-size: 12px !important;
}
</style>
